(function (global) {
  
  /**
  * Функции отвечающие за работу пенелей инструментов
  * @namespace Core.header
  * @since 5.0.0.410?? Версия по интерфейсам
  */
  global.header = {};
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Функции отвечающие за работу главную риббон панель инструментов с кнопками.
  * @namespace Core.header.extraActions
  * @since 5.0.0.410??
  */
  global.header.actions = {};
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

})(window.Core);